<app-cp-compare-sidebar-home></app-cp-compare-sidebar-home>
<app-cp-compare-sidebar-rooms></app-cp-compare-sidebar-rooms>
